// extracted by mini-css-extract-plugin
module.exports = {"Main":"styles_Main__3tX7o","contentContainer":"styles_contentContainer__k2ngf","bgTabsStyle":"styles_bgTabsStyle__2ic3L"};